var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/"}},[_c('img',{class:this.img_class,attrs:{"src":require("../../assets/logo.svg"),"alt":"XY Academy Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }